import { lazy } from 'react';
const GatePassEnter = lazy(() => import('./GatePassEnter'));

const GatePassEnterRoutes = [
  {
    path: '/gate-pass-enter',
    component: GatePassEnter
  }
];

export default GatePassEnterRoutes;
